import styled from 'styled-components'
import noImageBottle from '../_assets/no-bottle-image.svg'

export const Wrapper = styled.div.attrs(() => ({
  className: 'tech-sheet-content',
}))`
  box-sizing: border-box;
  width: 100%;
  height: 556px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  padding: 24px 24px 0 0;
`

export const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  width: 172px;
  height: 482px;
  margin: 0 24px;
  background: url('${props => props.src || noImageBottle}') no-repeat center;
  background-size: contain;
`

export const Columns = styled.div.attrs(() => ({
  className: 'tech-sheet-columns',
}))`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
`
